<template>
    <div class="login-wrapper-page">
        <div class="panel login-panel">
            <div class="login-panel-heading">
                <div class="login-logo"></div>
            </div>
            <div class="login-panel-body">
                <hr>
                <h3 class="text-center"><b>Two Factor Authentication</b></h3>
                <h5 class="text-muted text-center"><b>A verification code has been sent to your email</b></h5>
                <div>
                    <form class="form-group" @submit="verifyCode">
                        <div class="col-xs-10 col-xs-offset-1" style="margin-bottom: 10px;">
                            <ac-masked-text-box v-model="verificationCode" :mask="'000000'">

                            </ac-masked-text-box>
                        </div>
                        <div class="form-group">
                            <div class="col-xs-11 col-xs-offset-1" style="margin-bottom: 10px;">
                                <input type="checkbox" class="form-control filled-in" id="remember-me" v-model="rememberMe">
                                <label for="remember-me">Remember me</label>
                                <div>
                                    <small>If you trust this device and don't want to be asked for a verification code
                                        everytime you login check off the remember me option</small>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center">
                            <div class="col-xs-12">
                                <ac-button class="btn btn-blue" :action="resend" v-if="resendCount<3" type="button">
                                    RESEND
                                </ac-button>
                                <ac-button class="btn btn-green" :action="verifyCode" type="submit">
                                    VERIFY CODE
                                </ac-button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <hr/>
                    </div>
                </div>
                <div class="col-md-7">
                    <p>
                        <small>
                            Your security and safety is important to us. All personal information is encrypted and safeguarded using the highest level of security standards.
                            To learn more, please view our <a href="https://www.myameriflex.net/Document/Viewer/b0fa2e6c69d14b70aa297454326302ce" target="_blank">Privacy Policy</a>.
                        </small>
                    </p>
                </div>
                <div class="col-md-5">
                    <p><img class="pull-right" src="../../../assets/images/hipaa-150.png"></p>
                </div>
            </div>
        </div> <!--close panel -->
    </div>
</template>

<script>
    import {api} from "../../../global/framework/api.js";
    import {common} from "../../../global/common.js";

    export default {
        name: "TwoFactorAuthentication",
        data() {
            return {
                verificationCode: '',
                registrationComplete: false,//TODO: check if this is really necessary
                rememberMe: false,
                resendCount: 0
            };
        },
        methods: {
            async resend() {
                let result = await api.post('Account', 'Resend', null);
                if (result) {
                    this.resendCount++;
                }
            },
            async verifyCode() {
                let data = await api.getNoId('Account', `GetTempToken/${this.verificationCode}`);
                if (data) {
                    let redirectUrl = this.$route.query.urlRedirect || null;
                    let self = this;
                    $.ajax({
                        type: "POST",
                        disablePrefilter: true,
                        disableBeforeSendHandler: true,
                        url: common.APP_CONFIG.ROOT_URL + "AcressaOAuth/token",
                        data: {
                            associatedUserId: data.userId,
                            twoFactorAuthToken: data.token,
                            verificationCode: this.verificationCode,
                            grant_type: "password",
                            client_id: "AcressaJsApp"
                        },
                        success: function (tokenResponse) {
                            window.localStorage.removeItem("acressaToken");
                            let regComp = self.registrationComplete ? '/true' : '';
                            localStorage.acressaToken = 'Bearer ' + tokenResponse.access_token;
                            if (self.rememberMe) {
                                let currentTokens = JSON.parse(localStorage.getItem('permanent-remember-me-tokens')) || [];
                                let map = {};
                                map[data.rememberMeTokenKey] = data.rememberMeToken;
                                currentTokens = currentTokens.filter((el) => !el.hasOwnProperty(data.rememberMeTokenKey));
                                currentTokens.push(map);
                                localStorage.setItem(`permanent-remember-me-tokens`, JSON.stringify(currentTokens));
                            }
                            if (!!redirectUrl) {
                                window.location.href = redirectUrl;
                            } else {
                                window.location.href = "/" + tokenResponse.dashboard.toLowerCase() + "/#/" + tokenResponse.entityId + "/dashboard" + regComp;
                            }

                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>